import { v4 as uuid } from 'uuid';

import { definitions } from '@luxuryescapes/contract-svc-promo';

type VoucherReward = definitions['VoucherRewardV1'];
type VoucherRewardCurrencyCode = VoucherReward['currency_code'];

type CreateVoucherRewardOptions = {
  previousReward?: VoucherReward;
  newId?: string;
  defaultCurrencyCode: VoucherRewardCurrencyCode;
  defaultRewardAmount: number;
  defaultProducts: NonNullable<VoucherReward['products']>;
  defaultMinSpend: number;
  defaultMinSpendProducts: NonNullable<VoucherReward['min_spend_products']>;
};

export function copyVoucherReward(reward: VoucherReward, newId = uuid()): VoucherReward {
  return {
    ...reward,
    id_voucher_reward: newId,
    products: [...(reward.products ?? [])],
    min_spend_products: [...(reward.min_spend_products ?? [])],
  };
}

export function createVoucherReward({
  previousReward,
  newId = uuid(),
  defaultCurrencyCode,
  defaultRewardAmount,
  defaultProducts,
  defaultMinSpend,
  defaultMinSpendProducts,
}: CreateVoucherRewardOptions): VoucherReward {
  if (previousReward) {
    return {
      ...copyVoucherReward(previousReward, newId),
      currency_code: (previousReward.currency_code || defaultCurrencyCode) as VoucherRewardCurrencyCode,
    };
  }

  return {
    id_voucher_reward: newId,
    reward_amount: defaultRewardAmount,
    products: [...defaultProducts],
    min_spend: defaultMinSpend,
    currency_code: defaultCurrencyCode,
    min_spend_products: [...defaultMinSpendProducts],
  };
}
